import type { VK } from "../define/define";

export const keyCodeToVKMap: { [key: string]: VK } = {
    'Backspace': 0x08 as VK, // VK_BACK
    'Tab': 0x09 as VK, // VK_TAB
    'Enter': 0x0D as VK, // VK_RETURN
    'ShiftLeft': 0xA0 as VK, // VK_LSHIFT
    'ShiftRight': 0xA1 as VK, // VK_RSHIFT
    'ControlLeft': 0xA2 as VK, // VK_LCONTROL
    'ControlRight': 0xA3 as VK, // VK_RCONTROL
    'AltLeft': 0xA4 as VK, // VK_LMENU
    'AltRight': 0xA5 as VK, // VK_RMENU
    'Pause': 0x13 as VK, // VK_PAUSE
    'CapsLock': 0x14 as VK, // VK_CAPITAL
    'Escape': 0x1B as VK, // VK_ESCAPE
    'Space': 0x20 as VK, // VK_SPACE
    'PageUp': 0x21 as VK, // VK_PRIOR
    'PageDown': 0x22 as VK, // VK_NEXT
    'End': 0x23 as VK, // VK_END
    'Home': 0x24 as VK, // VK_HOME
    'ArrowLeft': 0x25 as VK, // VK_LEFT
    'ArrowUp': 0x26 as VK, // VK_UP
    'ArrowRight': 0x27 as VK, // VK_RIGHT
    'ArrowDown': 0x28 as VK, // VK_DOWN
    'PrintScreen': 0x2C as VK, // VK_SNAPSHOT
    'Insert': 0x2D as VK, // VK_INSERT
    'Delete': 0x2E as VK, // VK_DELETE
    'Digit0': 0x30 as VK, // VK_0
    'Digit1': 0x31 as VK, // VK_1
    'Digit2': 0x32 as VK, // VK_2
    'Digit3': 0x33 as VK, // VK_3
    'Digit4': 0x34 as VK, // VK_4
    'Digit5': 0x35 as VK, // VK_5
    'Digit6': 0x36 as VK, // VK_6
    'Digit7': 0x37 as VK, // VK_7
    'Digit8': 0x38 as VK, // VK_8
    'Digit9': 0x39 as VK, // VK_9
    'KeyA': 0x41 as VK, // VK_A
    'KeyB': 0x42 as VK, // VK_B
    'KeyC': 0x43 as VK, // VK_C
    'KeyD': 0x44 as VK, // VK_D
    'KeyE': 0x45 as VK, // VK_E
    'KeyF': 0x46 as VK, // VK_F
    'KeyG': 0x47 as VK, // VK_G
    'KeyH': 0x48 as VK, // VK_H
    'KeyI': 0x49 as VK, // VK_I
    'KeyJ': 0x4A as VK, // VK_J
    'KeyK': 0x4B as VK, // VK_K
    'KeyL': 0x4C as VK, // VK_L
    'KeyM': 0x4D as VK, // VK_M
    'KeyN': 0x4E as VK, // VK_N
    'KeyO': 0x4F as VK, // VK_O
    'KeyP': 0x50 as VK, // VK_P
    'KeyQ': 0x51 as VK, // VK_Q
    'KeyR': 0x52 as VK, // VK_R
    'KeyS': 0x53 as VK, // VK_S
    'KeyT': 0x54 as VK, // VK_T
    'KeyU': 0x55 as VK, // VK_U
    'KeyV': 0x56 as VK, // VK_V
    'KeyW': 0x57 as VK, // VK_W
    'KeyX': 0x58 as VK, // VK_X
    'KeyY': 0x59 as VK, // VK_Y
    'KeyZ': 0x5A as VK, // VK_Z
    'MetaLeft': 0x5B as VK, // VK_LWIN
    'MetaRight': 0x5C as VK, // VK_RWIN
    'ContextMenu': 0x5D as VK, // VK_APPS
    'Numpad0': 0x60 as VK, // VK_NUMPAD0
    'Numpad1': 0x61 as VK, // VK_NUMPAD1
    'Numpad2': 0x62 as VK, // VK_NUMPAD2
    'Numpad3': 0x63 as VK, // VK_NUMPAD3
    'Numpad4': 0x64 as VK, // VK_NUMPAD4
    'Numpad5': 0x65 as VK, // VK_NUMPAD5
    'Numpad6': 0x66 as VK, // VK_NUMPAD6
    'Numpad7': 0x67 as VK, // VK_NUMPAD7
    'Numpad8': 0x68 as VK, // VK_NUMPAD8
    'Numpad9': 0x69 as VK, // VK_NUMPAD9
    'NumpadMultiply': 0x6A as VK, // VK_MULTIPLY
    'NumpadAdd': 0x6B as VK, // VK_ADD
    'NumpadSubtract': 0x6D as VK, // VK_SUBTRACT
    'NumpadDecimal': 0x6E as VK, // VK_DECIMAL
    'NumpadDivide': 0x6F as VK, // VK_DIVIDE
    'F1': 0x70 as VK, // VK_F1
    'F2': 0x71 as VK, // VK_F2
    'F3': 0x72 as VK, // VK_F3
    'F4': 0x73 as VK, // VK_F4
    'F5': 0x74 as VK, // VK_F5
    'F6': 0x75 as VK, // VK_F6
    'F7': 0x76 as VK, // VK_F7
    'F8': 0x77 as VK, // VK_F8
    'F9': 0x78 as VK, // VK_F9
    'F10': 0x79 as VK, // VK_F10
    'F11': 0x7A as VK, // VK_F11
    'F12': 0x7B as VK, // VK_F12
    'NumLock': 0x90 as VK, // VK_NUMLOCK
    'ScrollLock': 0x91 as VK, // VK_SCROLL
    'Semicolon': 0xBA as VK, // VK_OEM_1
    'Equal': 0xBB as VK, // VK_OEM_PLUS
    'Comma': 0xBC as VK, // VK_OEM_COMMA
    'Minus': 0xBD as VK, // VK_OEM_MINUS
    'Period': 0xBE as VK, // VK_OEM_PERIOD
    'Slash': 0xBF as VK, // VK_OEM_2
    'Backquote': 0xC0 as VK, // VK_OEM_3
    'BracketLeft': 0xDB as VK, // VK_OEM_4
    'Backslash': 0xDC as VK, // VK_OEM_5
    'BracketRight': 0xDD as VK, // VK_OEM_6
    'Quote': 0xDE as VK, // VK_OEM_7
    'IntlBackslash': 0xE2 as VK, // VK_OEM_102
    // 添加更多的键映射
};

export const mouseKeyToCodeMap: { [code: number]: VK } = {
    // 鼠标按键映射
    0x00: 0x01 as VK,  // MouseLeft 
    0x02: 0x02 as VK,  // MouseRight 
    0x01: 0x04 as VK,  // MouseMiddle 
    0x03: 0x05 as VK,  // MouseBack 后退按钮）
    0x04: 0x06 as VK,  // MouseForward（前进按钮）
    0x10: 0x9c as VK, // MouseWheelUp
    0x11: 0x9d as VK, // MouseWheelDown
}
